export const CUSTOM_CLEAR_PRODUCT_SCOPE = '[Product] Clear Product Scope';

export class CustomClearProductScope {
  readonly type = CUSTOM_CLEAR_PRODUCT_SCOPE;
}
